'use client';
/** @jsxImportSource @emotion/react */

import type { TimelineSeparatorProps } from '@mui/lab/TimelineSeparator';

import MuiTimelineSeparator from '@mui/lab/TimelineSeparator';

export type { TimelineSeparatorProps };

export const TimelineSeparator: React.FC<TimelineSeparatorProps> =
  MuiTimelineSeparator;

TimelineSeparator.displayName = 'TimelineSeparator';
